import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CaseConvert } from "../utils/case-convert";
import { map } from 'rxjs/operators';
import { ContextService } from 'src/app/services';

/**
 * This interceptor ensures that JSON objects from Xena Api are camel cased.
 */
@Injectable({
  providedIn: 'root'
})
export class CaseConvertInterceptor implements HttpInterceptor {

  constructor(private context: ContextService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(map((response: HttpResponse<any>) => {
      if (response.clone && request.url.startsWith(this.context.serviceUrl)) {
        response = response.clone({ body: CaseConvert.keysToCamel(response.body) });
      }
      return response;
    }));
  }

}
